/**
 * @ngdoc run
 * @memberof mercury.modules.thirdparty.intercom
 * @name IntercomRun
 * @description Intercom functionality, initialised during app startup
 */
angular.module('mercury.modules.thirdparty.intercom')
.run(["$window", "logger", "userinfo", "helperUtils", function intercomRun($window, logger, userinfo, helperUtils) {

  // Main Intercom module entrypoint, awaits user info before proceeding
  userinfo.ready()
    .then(function(userDetails) {

      const allCompanies = userinfo.companies();
      const activeCompany = allCompanies.find(company => company.id === userinfo.activeCompany());

      // Base intercom config
      window.intercomSettings = {
        hide_default_launcher: true,
        custom_launcher_selector: '.intercom-launcher',
        alignment: 'right',
        vertical_padding: 20,
        horizontal_padding: 20,
        app_id: 'kse39le3',
      }

      const dynamicConfig = {
        user_id: userDetails.id,
        user_hash: userDetails.intercomUserHash,
        name: userDetails.firstName + ' ' + userDetails.lastName,
        email: userDetails.email,
        company: {
          company_id: activeCompany.id,
          name: activeCompany.name,
        }
      }

      logger.info('Configuring Intercom with dynamic config', dynamicConfig);

      // Dynamic intercom config
      window.Intercom('boot', dynamicConfig);

      // Create badge for unread message count
      const badge = document.createElement('span');
      badge.id = 'intercom-unread-badge';
      badge.style.cssText = `
          position: absolute;
          top: 8px;
          right: 6px;
          background-color: #dc3545;
          color: white;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-family: Arial, sans-serif;
          visibility: hidden;
      `;

      helperUtils.waitForSelector('.intercom-launcher', function(launcherEl) {
        launcherEl.appendChild(badge);
      });

      // Update badge when unread count changes. Unhelpfully, Intercom will always
      // send us two of these events in quick succession, the first with the new
      // message count value and then straight away with '0' because their current
      // behaviour is to automatically show the message in a minimal version of their
      // widget.
      //
      // We listen for non-zero counts, and show this in the badge. We then remove
      // the badge when the user opens the full message view (which triggers the
      // 'onShow' event).
      window.Intercom('onUnreadCountChange', function(unreadCount) {
        if (unreadCount !== 0) {
          badge.style.visibility = 'visible';
          badge.textContent = unreadCount;
        }
      });

      window.Intercom('onShow', function() {
        badge.style.visibility = 'hidden';
      });

    });

}]);
